// CommonFunc.js

export const getPosition = () => {
    return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
            const options = {
                enableHighAccuracy: true,
                maximumAge: 0,
                timeout: 10000
                //timeout: Infinity
            };
            navigator.geolocation.getCurrentPosition(resolve, reject, options);
        } else {
            //alert("No GPS supported!");
            reject('No Geolocation!');
        }
    });
};


